import { render, staticRenderFns } from "./CompanyDataUpdateAttachments.vue?vue&type=template&id=08dc507e&scoped=true&"
import script from "./CompanyDataUpdateAttachments.vue?vue&type=script&lang=js&"
export * from "./CompanyDataUpdateAttachments.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDataUpdateAttachments.vue?vue&type=style&index=0&id=08dc507e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dc507e",
  null
  
)

export default component.exports